module.exports = __webpack_public_path__ + "static/media/python.b8fb7f80.png";